<template>
  <div class="absolute top-0 z-50  w-full h-full flex items-center justify-center">
    
    <div class=" w-full h-full bg-gray-500 blur-lg opacity-70"></div>

    <div class=" orderPanel  absolute flex flex-col m-auto w-10/12 md:w-4/5 md:max-w-sm rounded bg-slate-200">
      <div class="flex border-b border-blue-400 p-2">
        <div class="ml-auto font-bold text-xl">Sign Up</div>
        <div v-on:click="close()" class=" ml-auto w-8 h-8 bg-slate-100 border-slate-300 rounded-full flex active:scale-75 hover:scale-105">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=" w-7 h-7 m-auto">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        </div>
      </div>

      <div class=" md:h-auto" >
        
        <div class=" flex flex-col p-6">
           <input class=" m-2 md:m-4" type="text" v-model="username" placeholder="Enter User Name" />
           <input class=" m-2 md:m-4" type="text" v-model="firstname" placeholder="Enter First Name" />
           <input class=" m-2 md:m-4" type="text" v-model="lastname" placeholder="Enter Last Name" />
           <input class=" m-2 md:m-4" type="text" v-model="email" placeholder="Enter Email" />
           <input class=" m-2 md:m-4" type="text" v-model="phone" placeholder="Enter Phone Number" />
           <input class=" m-2 md:m-4" type="password" v-model="password" placeholder="Enter Password" />
           <input class=" m-2 md:m-4" type="password" v-model="password2" placeholder="ReEnter Password" />

           <p v-if="errors.length">
            <b>Please correct the following error(s):</b>
              <ul class=" text-red-500">
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
            </p>
          
           <button 
            class=" bg-gray-200 font-bold text-gray-600 cursor-pointer shadow p-2 mx-auto" 
            v-on:click="signUp()"> 
            SignUp
          </button>
          
           <div class=" mt-2"> Already Have an Account? <span v-on:click="logIn()" class=" font-semibold cursor-pointer"> LogIn Here</span>
           </div>
        </div>
      </div>
    
    
    </div>

  
  </div>
</template>

<script>
// @ is an alias to /src

import axios from "axios";
export default {
  name: 'SingUpView',
  components: {
    // signUpPage: SignUpPage,
  },
  data () {
       return{
        username:'',
        firstname:'',
        lastname:'',
        email:'',
        phone:'',
        password:'',
        password2:'',

        errors: [],
        BackendUrl: "https://labsapi.packymstechnology.com"
       }
      },
  methods:{
   async signUp(){
    this.checkForm();
     if(this.errors.length){
       // this.warnShakeError()
        console.log("Still have an Error")
      }
      else{
        this.$parent.showLoading(true)
        let dev = process.env.VUE_APP_DEVELOPMENT;    
        if (dev == "true") {
          console.log("is in dev mode")
          this.BackendUrl = "";
        }
        try {
          let result = await axios.post(this.BackendUrl + "/users", {
          username:this.username,
          first_name:this.firstname,
          last_name:this.lastname,
          phone_number:this.phone,
          email: this.email,
          password:this.password
        });

        console.log(result)

        if(result.status == 200){
          // alert("Signed up ready to login")
          this.$parent.setMessageBox("Signed up, ready to login", "accepted")
          this.logIn();
          //bring up login page
        } else {
          alert("there was an error")
          
          
        }
        } catch (error) {
          const code = error.response.status
          if(code == 403){
            this.$parent.setMessageBox("Username or email already taken", "warning")
          } else{
            this.$parent.setMessageBox("Something went wrong, Please check your internet connection or try again later", "error")
          }
        }
        
        this.$parent.showLoading(false)
        }
    
    },
    checkForm(){
            this.errors = [];
            if (!this.username) {
              this.errors.push("User Name required.");
            }
            if (!this.firstname) {
              this.errors.push("First name required.");
            }
            if (!this.lastname) {
              this.errors.push("Last name required.");
            }
            if (!this.email) {
              this.errors.push('Email required.');
            } else if (!this.validEmail(this.email)) {
              this.errors.push('Valid email required.');
            }
            if (!this.phone) {
              this.errors.push("Phone Number required.");
            }
            if (!this.password) {
              this.errors.push("Password is required.");
            }else if(this.password.length < 6){
              this.errors.push("Password need to be atleast 6 characters.");
            } else{             
              if (this.password != this.password2) {
                this.errors.push("Re-entered password does not match");
              }
            }
           
        },
        validEmail(email){
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
    logIn(){
      this.$parent.showLogin(true);
      this.$parent.showSignUp(false);
    },
    close(){
      this.$parent.showSignUp(false);
    }

  }
  
}
</script>

<style scoped>

.panel{
  max-height: 80%;
}

</style>
